import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
// import { BrowserRouter, Switch, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

import "./App.css";
import Navbar from "./components/Navbar";
import NotFound from "./components/NotFound";
import Home from "./pages/Home";
import ContactUs from "./pages/ContactUs";
import AboutUs from "./pages/AboutUs";

import Products from "./pages/Products";
import ProductSensor from "./pages/ProductSensor";
import ProductTouch from "./pages/ProductTouch";
import ProductTouchLcm from "./pages/ProductTouchLcm";
import ProductTpCtrlBd from "./pages/ProductTpCtrlBd";
import ProductLcmAdBd from "./pages/ProductLcmAdBd";

import Supports from "./pages/Supports";
import SupportSensor from "./pages/SupportSensor";
import SupportTouch from "./pages/SupportTouch";
import SupportTouchLcm from "./pages/SupportTouchLcm";

import Services from "./pages/Services";
import ServiceMarket from "./pages/ServMarket";
import ServiceConsult from "./pages/ServConsult";
import ServiceDesign from "./pages/ServDesign";
import ServiceDevelop from "./pages/ServDevelop";

import SignUp from "./pages/SignUp";

import CRUDSensors from "./elements_crud/CRUDSensors";
import CreateSensor from "./elements_crud/CreateSensor";
import EditSensor from "./elements_crud/EditSensor";
import CRUDSensorsBySize from "./elements_crud/CRUDSensorsBySize";

import CRUDTouchs from "./elements_crud/CRUDTouchs";
import CreateTouch from "./elements_crud/CreateTouch";
import EditTouch from "./elements_crud/EditTouch";
import CRUDTouchsBySize from "./elements_crud/CRUDTouchsBySize";

import ListingSensors from "./listing_product/ListingSensors";
import ListingTouchs from "./listing_product/ListingTouchs";
import ListingSensorsBySize from "./listing_product/ListingSensorsBySize";
import ListingTouchsBySize from "./listing_product/ListingTouchsBySize";
import ShowSensorDetail from "./listing_product/ShowSensorDetail";
import ShowTouchDetail from "./listing_product/ShowTouchDetail";

import ViewPDF from "./listing_product/ViewPDF";

function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/ContactUs" element={<ContactUs />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/Products" element={<Products />} />
          <Route path="/Supports" element={<Supports />} />
          <Route path="/SignUp" element={<SignUp />} />

          <Route path="/Services" element={<Services />} />
          <Route path="/ServiceMarket" element={<ServiceMarket />} />
          <Route path="/ServiceDevelop" element={<ServiceDevelop />} />
          <Route path="/ServiceDesign" element={<ServiceDesign />} />
          <Route path="/ServiceConsult" element={<ServiceConsult />} />

          <Route path="/ProductSensor" element={<ProductSensor />} />
          <Route path="/ProductTouch" element={<ProductTouch />} />
          <Route path="/ProductTouchLcm" element={<ProductTouchLcm />} />
          <Route path="/ProductTpCtrlBd" element={<ProductTpCtrlBd />} />
          <Route path="/ProductLcmAdBd" element={<ProductLcmAdBd />} />

          <Route path="/SupportSensor" element={<SupportSensor />} />
          <Route path="/SupportTouch" element={<SupportTouch />} />
          <Route path="/SupportTouchLcm" element={<SupportTouchLcm />} />

          <Route path="/CRUDSensors" element={<CRUDSensors />} />
          <Route path="/CreateSensor" element={<CreateSensor />} />
          <Route path="/EditSensor/:id" element={<EditSensor />} />
          <Route path="/ShowSensorDetail/:id" element={<ShowSensorDetail />} />
          <Route path="/CRUDSensorsBySize/:id" element={<CRUDSensorsBySize />} />

          <Route path="/CRUDTouchs" element={<CRUDTouchs />} />
          <Route path="/CreateTouch" element={<CreateTouch />} />
          <Route path="/EditTouch/:id" element={<EditTouch />} />
          <Route path="/ShowTouchDetail/:id" element={<ShowTouchDetail />} />
          <Route path="/CRUDTouchsBySize/:id" element={<CRUDTouchsBySize />} />

          <Route path="/ListingSensors" element={<ListingSensors />} />
          <Route path="/ListingTouchs" element={<ListingTouchs />} />
          <Route path="/ListingSensorsBySize/:id" element={<ListingSensorsBySize />} />
          <Route path="/ListingTouchsBySize/:id" element={<ListingTouchsBySize />} />

          <Route path="/ViewPDF/:viewid" element={<ViewPDF />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
